import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Snackbar, Button } from '@mui/material';

export default function PWAUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      if (!registration) return;

      // Check for updates every hour
      const intervalId = setInterval(() => {
        registration.update();
      }, 60 * 60 * 1000);

      // Return cleanup function (stored in registration for access in effect)
      registration._cleanupInterval = intervalId;
    },
    onRegisterError(error) {
      console.error('Service worker registration failed:', error);
    },
  });

  // Cleanup interval on unmount
  useEffect(() => {
    return () => {
      if (navigator.serviceWorker?.ready) {
        navigator.serviceWorker.ready.then((registration) => {
          if (registration._cleanupInterval) {
            clearInterval(registration._cleanupInterval);
          }
        });
      }
    };
  }, []);

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  return (
    <>
      <Snackbar
        open={offlineReady}
        message="App ready to work offline"
        autoHideDuration={5000}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      <Snackbar
        open={needRefresh}
        message="A new version is available"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        action={
          <>
            <Button
              color="primary"
              size="small"
              onClick={() => updateServiceWorker(true)}
            >
              Update
            </Button>
            <Button color="inherit" size="small" onClick={close}>
              Dismiss
            </Button>
          </>
        }
      />
    </>
  );
}
